import React from "react";
import ConfirmOtp from "../Components/confirm-otp/ConfirmOtp";

const Home = React.lazy(() => import("../View/Home/Home"));
const Provider = React.lazy(() => import("../View/Provider/Provider"));
const Profile = React.lazy(() => import("../View/Profile/Profile"));
const Users = React.lazy(() => import("../View/Users/Users"));
const Organization = React.lazy(() =>
  import("../View/Organizations/Organizations")
);
const AiVerificationCalls = React.lazy(() =>
  import("../View/AiVerificationCalls/AiVerificationCalls")
);
const DoctorLogsPage = React.lazy(() =>
  import("../View/DoctorLogsPage/DoctorLogsPage")
);
const DoctorProfile = React.lazy(() =>
  import("../View/DoctorProfile/DoctorProfile")
);

const LoginPage = React.lazy(() => import("../View/Auth/UserLogin/UserLogin"));
const EmailConfirmation = React.lazy(() =>
  import("../View/Auth/ConfirmationPage/EmailAction")
);
const PasswordAction = React.lazy(() =>
  import("../View/Auth/ConfirmationPage/PasswordAction")
);
const ResetPassword = React.lazy(() =>
  import("../View/Auth/ResetPassword/ResetPassword")
);

const components = {
  Home: {
    path: "/base/home",
    name: "home",
    element: <Home />,
  },
  Provider: {
    path: "/base/provider",
    name: "provider",
    element: <Provider />,
  },
  Profile: {
    path: "/base/profile",
    name: "Profile",
    element: <Profile />,
  },
  Users: {
    path: "/base/users",
    name: "User",
    element: <Users />,
  },
  Organization: {
    path: "/base/organization",
    name: "Organization",
    element: <Organization />,
  },
  AiVerificationCalls: {
    path: "/base/ai-verification-calls",
    name: "AiVerificationCalls",
    element: <AiVerificationCalls />,
  },
  DoctorLogsPage: {
    path: "/base/doctor-logs",
    name: "DoctorLogsPage",
    element: <DoctorLogsPage />,
  },
  DoctorProfile: {
    path: "/base/doctor-profile/:npi",
    name: "DoctorProfile",
    element: <DoctorProfile />,
  },
  LoginPage: {
    path: "/",
    name: "Login",
    element: <LoginPage />,
  },

  ResetPassword: {
    path: "/reset-password",
    name: "ResetPassword",
    element: <ResetPassword />,
  },

  EmailAction: {
    path: "/confirm-email/:userId/*",
    name: "EmailConfirmation",
    element: <EmailConfirmation />,
  },

  PasswordAction: {
    path: "/set-password/:userId/*",
    name: "SetPassword",
    element: <PasswordAction />,
  },
  ConfirmOtp: {
    path: "/confirm-otp/:token/*",
    name: "ConfirmOtp",
    element: <ConfirmOtp />,
  },
};
const rolesConfig = {
  System_Admin: {
    routes: [
      components.Home,
      components.Provider,
      components.Profile,
      components.Organization,
      components.Users,
      components.AiVerificationCalls,
      components.DoctorLogsPage,
      components.DoctorProfile,
    ],
  },
  Org_Admin: {
    routes: [
      components.Home,
      components.Provider,
      components.Profile,
      components.Users,
      components.AiVerificationCalls, // TEMPORARY — demo only, revert once real Sys_Admin login available
      components.DoctorLogsPage,
      components.DoctorProfile,
    ],
  },
  User: {
    routes: [
      components.Home,
      components.Provider,
      components.Profile,
      components.AiVerificationCalls, // TEMPORARY — demo only, revert once real Sys_Admin login available
      components.DoctorLogsPage,
      components.DoctorProfile,
    ],
  },
};
const BasicRoutesConfig = [
  components.LoginPage,
  components.ResetPassword,
  components.EmailAction,
  components.PasswordAction,
  components.ConfirmOtp,
];
export { rolesConfig, BasicRoutesConfig };